import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import logo from '../../../../EagleLogo.png';
import Button from '@material-ui/core/Button';
import Login from '../../../../dashboard/components/Login';

const useStyles = makeStyles((theme) => ({
	grow: {
		flexGrow: 1,
	},
	title: {
		fontSize: '1.45rem',
		display: 'none',
		color: theme.palette.text.secondary,
		[theme.breakpoints.up('sm')]: {
			display: 'block',
		},
		textTransform: 'uppercase',
		fontWeight: 'bold',
	},
	datePicker: {
		margin: 0,
	},
	datePickerInput: {
		width: 130,
		fontSize: 13,
	},
	lableSpan: {
		marginRight: 12,
	},
	table: {
		padding: '7px 7px 0 0',
		borderSpacing: 0,
	},
	button: {
		margin: theme.spacing(1),
	},
	logo: {
		height: 35,
		margin: '0 15px',
		marginTop: 5,
		cursor: 'pointer',
	},
	placeHolderDiv: {
		width: '100%',
		height: '100%',
		padding: '1px 5px',
		position: 'relative',
	},
	placeHolder: {
		top: '50%',
		transform: 'translateY(-50%)',
		padding: '1px 5px',
		paddingRight: 25,
		position: 'absolute',
		fontStyle: 'italic',
		fontSize: 14,
	},
	selectInput: {
		fontSize: 13,
		paddingBottom: 3,
	},
}));

const Header = (props) => {
	const { isLogin, loginUser, showNewEntry, loginActions, newentryActions } =
		props;

	const classes = useStyles();

	const handleLoginClick = () => {};

	const handleLogoClick = () => {
		if (isLogin) {
			newentryActions.setShowNewEntry(false);
		}
	};

	const handleLogoutClick = () => {
		loginActions.reset();
	};

	const getCookie = (name) => {
		var nameEQ = name + '=';
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	};

	useEffect(() => {
		if (newentryActions) {
			newentryActions.setShowNewEntry(true);
			const search = document.location.search;
			const params = new URLSearchParams(search);
			//process.env.NODE_ENV !== 'production'
			// if(!username && getCookie('username')) {
			//     username=getCookie('username');
			// }
			let username = params.get('username');
			let password = params.get('password');
			let userguid = params.get('userguid');
			let isCookie = false;

			if (!username && !userguid) {
				if (getCookie('u_cookie_username')) {
					isCookie = true;
				}
			}

			if (isCookie) {
				let u_cookie_username = getCookie('u_cookie_username');
				let u_cookie_fullname = getCookie('u_cookie_fullname');
				const uDetails = {
					username: u_cookie_username,
					name: u_cookie_fullname,
					isValid: true,
				};
				loginActions.setCookieLogin(uDetails);
			} else {
				//newentryActions.setShowNewEntry(true);
				const uDetails = {
					username: username,
					password: password,
					userguid: userguid,
				};

				loginActions.checklogin(uDetails);
			}
			newentryActions.requestVisiterEntries();
		}
	}, [newentryActions]);

	return (
		<div className={classes.grow}>
			<Toolbar>
				<img
					onClick={handleLogoClick}
					className={classes.logo}
					src={logo}
					alt="Eagle"
				/>
				<div className={classes.grow} />
				<Typography className={classes.title} variant="h6" noWrap>
					{!showNewEntry ? props.title : 'VISITOR REGISTRATION'}
				</Typography>

				<div className={classes.grow} />
				<table className={classes.table}>
					<tbody>
						<tr>
							<td>{isLogin && <div>Welcome {loginUser.name}</div>}</td>
							<td>
								{!isLogin ? (
									<Login
										isLogin={isLogin}
										handleLoginClick={handleLoginClick}
										handleLogoutClick={handleLogoutClick}
									></Login>
								) : (
									<Button
										variant="contained"
										color="secondary"
										className={classes.button}
										onClick={handleLogoutClick}
									>
										Logout
									</Button>
								)}
							</td>
						</tr>
					</tbody>
				</table>
			</Toolbar>
		</div>
	);
};

Header.propTypes = {
	title: PropTypes.string.isRequired,
	portfolio: PropTypes.string,
	effectiveDate: PropTypes.object,
};

export default Header;
